//taskActions.js

import axios from "axios";
import { toast } from "react-hot-toast";

export const FETCH_TASKS_REQUEST = "FETCH_TASKS_REQUEST";
export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const FETCH_TASKS_FAILURE = "FETCH_TASKS_FAILURE";

export const CREATE_TASK_SUBMIT_REQUEST = "CREATE_TASK_SUBMIT_REQUEST";
export const CREATE_TASK_SUBMIT_SUCCESS = "CREATE_TASK_SUBMIT_SUCCESS";
export const CREATE_TASK_SUBMIT_FAILURE = "CREATE_TASK_SUBMIT_FAILURE";

export const FETCH_APPROVED_TASKS_REQUEST = "FETCH_APPROVED_TASKS_REQUEST";
export const FETCH_APPROVED_TASKS_SUCCESS = "FETCH_APPROVED_TASKS_SUCCESS";
export const FETCH_APPROVED_TASKS_FAILURE = "FETCH_APPROVED_TASKS_FAILURE";

export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

export const FETCH_REJECTED_OR_PENDING_TASKS_REQUEST =
  "FETCH_REJECTED_OR_PENDING_TASKS_REQUEST";
export const FETCH_REJECTED_OR_PENDING_TASKS_SUCCESS =
  "FETCH_REJECTED_OR_PENDING_TASKS_SUCCESS";
export const FETCH_REJECTED_OR_PENDING_TASKS_FAILURE =
  "FETCH_REJECTED_OR_PENDING_TASKS_FAILURE";

export const START_TASKS_REQUEST = "START_TASKS_REQUEST";
export const START_TASKS_SUCCESS = "START_TASKS_SUCCESS";
export const START_TASKS_FAILURE = "START_TASKS_FAILURE";

export const END_TASKS_REQUEST = "END_TASKS_REQUEST";
export const END_TASKS_SUCCESS = "END_TASKS_SUCCESS";
export const END_TASKS_FAILURE = "END_TASKS_FAILURE";

export const DO_LATER_TASKS_REQUEST = "DO_LATER_TASKS_REQUEST";
export const DO_LATER_TASKS_SUCCESS = "DO_LATER_TASKS_SUCCESS";
export const DO_LATER_TASKS_FAILURE = "DO_LATER_TASKS_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchTasks = () => async (dispatch) => {
  dispatch({ type: FETCH_TASKS_REQUEST });

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/get-all-tasks`);
    const { data, meta } = response.data;

    if (meta.status) {
      dispatch({ type: FETCH_TASKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_TASKS_FAILURE, payload: meta.message });
      toast.error(meta.message || "Failed to fetch tasks");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: FETCH_TASKS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};

// 🆕 Create task submission action
export const createTaskSubmit = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_TASK_SUBMIT_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      `${BASE_URL}/v1/api/create-task-submit`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    dispatch({ type: CREATE_TASK_SUBMIT_SUCCESS, payload: res.data });
    toast.success(res.data.meta?.message || "Task created successfully");
  } catch (error) {
    const message =
      error.response?.data?.meta?.message || "Failed to submit task";
    dispatch({ type: CREATE_TASK_SUBMIT_FAILURE, payload: message });
    toast.error(message);
  }
};

export const fetchApprovedTasks = () => async (dispatch) => {
  dispatch({ type: FETCH_APPROVED_TASKS_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${BASE_URL}/v1/api/get-task-submit?status=${`approved,ongoing,complete`}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const { data, meta } = response.data;

    if (meta.status) {
      dispatch({ type: FETCH_APPROVED_TASKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_APPROVED_TASKS_FAILURE, payload: meta.message });
      toast.error(meta.message || "Failed to fetch approved tasks");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: FETCH_APPROVED_TASKS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};
export const fetchApprovalTasks = () => async (dispatch) => {
  dispatch({ type: FETCH_APPROVED_TASKS_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${BASE_URL}/v1/api/get-task-submit?status=${`pending,rejected`}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const { data, meta } = response.data;

    if (meta.status) {
      dispatch({ type: FETCH_APPROVED_TASKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_APPROVED_TASKS_FAILURE, payload: meta.message });
      toast.error(meta.message || "Failed to fetch approved tasks");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: FETCH_APPROVED_TASKS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};

export const fetchLocations = () => async (dispatch) => {
  dispatch({ type: FETCH_LOCATIONS_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${BASE_URL}/v1/api/get-all-locations`, {
      headers: {
        Authorization: token,
      },
    });

    const { data, meta } = response.data;

    if (meta.status) {
      dispatch({ type: FETCH_LOCATIONS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_LOCATIONS_FAILURE, payload: meta.message });
      toast.error(meta.message || "Failed to fetch locations");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: FETCH_LOCATIONS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};

export const fetchRejectedOrPendingTasks = () => async (dispatch) => {
  dispatch({ type: FETCH_REJECTED_OR_PENDING_TASKS_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${BASE_URL}/v1/api/get-task-submit-rejected-or-pending`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const { data, meta } = response.data;

    if (meta.status) {
      dispatch({
        type: FETCH_REJECTED_OR_PENDING_TASKS_SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: FETCH_REJECTED_OR_PENDING_TASKS_FAILURE,
        payload: meta.message,
      });
      toast.error(meta.message || "Failed to fetch rejected/pending tasks");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({
      type: FETCH_REJECTED_OR_PENDING_TASKS_FAILURE,
      payload: errMsg,
    });
    toast.error(errMsg);
  }
};

// 🆕 Start Task action
export const startTask = (credentials) => async (dispatch) => {
  dispatch({ type: START_TASKS_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/v1/api/start-task`, credentials, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    console.log("start-task task------->>>", res);

    const { data, meta } = res.data;

    if (meta?.status) {
      console.log("start-task task------->>>", meta.message);

      dispatch({ type: START_TASKS_SUCCESS, payload: data });
      toast.success(meta.message);
    } else {
      dispatch({ type: START_TASKS_FAILURE, payload: meta.message });
      toast.error(meta.message);
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: START_TASKS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};

// 🆕 End Task action
export const endTask = (credentials) => async (dispatch) => {
  dispatch({ type: END_TASKS_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/v1/api/end-task`, credentials, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    console.log("end task------->>>", res);

    const { data, meta } = res.data;

    if (meta?.status) {
      dispatch({ type: END_TASKS_SUCCESS, payload: data });
      toast.success(meta.message || "Login successful");
    } else {
      dispatch({ type: END_TASKS_FAILURE, payload: meta.message });
      toast.error(meta.message);
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: END_TASKS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};
// 🆕 End Task action
export const doTaskLater = (credentials) => async (dispatch) => {
  dispatch({ type: DO_LATER_TASKS_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/v1/api/doitLater-task-tracking`,
      credentials,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("doitLater task------->>>", res);

    const { data, meta } = res.data;

    if (meta?.status) {
      dispatch({ type: DO_LATER_TASKS_SUCCESS, payload: data });
      toast.success(meta.message);
    } else {
      dispatch({ type: DO_LATER_TASKS_FAILURE, payload: meta.message });
      toast.error(meta.message);
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: DO_LATER_TASKS_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};
